import {
  NavigationActions,
  NavigationActionTypes,
} from '../actions/navigation.actions';
import { Navigation } from '@digitaix/types';

export interface NavigationState {
  config: Navigation;
}

export const navigationInitialState: NavigationState = {
  config: [],
};

export function navigationReducer(
  state = navigationInitialState,
  action: NavigationActions,
): NavigationState {
  switch (action.type) {
    case NavigationActionTypes.SetNavigationConfig:
      return { ...state, config: action.config };

    default:
      return state;
  }
}
